import React from 'react';

import DonutFiguresCard from '~support-at-home/components/common/DonutFiguresCard';
import SectionInfo from '~support-at-home/components/common/SectionInfo';

import { TRACKER_TEXT } from './trackerText';
import { TrackerOverviewView } from './transforms';

interface ComponentProps {
  data: TrackerOverviewView;
}

const Overview: React.FC<ComponentProps> = ({ data }) => (
  <DonutFiguresCard
    title="Budget Overview"
    description={TRACKER_TEXT.overview.section}
    titleAddon={<SectionInfo id="overview-section" label="Budget Overview" content={TRACKER_TEXT.overview.section} />}
    donut={{
      segments: data.segments,
      overSegments: data.overSegments,
      centreValue: data.centreValue,
      centreLabel: TRACKER_TEXT.overview.centreLabel,
      percentBase: data.percentBase,
      ariaLabel: data.ariaLabel,
      dataCy: 'tracker-overview-donut',
    }}
    over={data.over}
    dataCy="tracker-overview-card"
    legend={data.legend}
  />
);

export default Overview;
